import { DealType } from '@repo/database/src/types';
import { Transform } from 'class-transformer';
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsUUID, Max, Min, ValidateIf } from 'class-validator';

export class CreateAgentDealDto {
  @IsUUID(4, { message: 'Invalid user selected' })
  userId: string;

  @IsEnum(DealType, { message: 'Please select a valid deal type' })
  dealType: DealType;

  @IsNumber({}, { message: 'Please enter a valid rake share percentage' })
  @Min(5, { message: 'Rake share percentage must be at least 5%' })
  @Max(45, { message: 'Rake share percentage cannot exceed 45%' })
  rakeSharePercentage: number;

  @IsOptional()
  @IsNumber({}, { message: 'Please enter a valid flat fee amount' })
  @Min(0, { message: 'Flat fee must be a positive amount' })
  flatFee?: number | null;

  @IsOptional()
  @IsNumber({}, { message: 'Please enter a valid bonus amount' })
  @Min(0, { message: 'Bonus must be a positive amount' })
  bonus?: number | null;

  @IsDate({ message: 'Please select a valid start date' })
  @Transform(({ value }) => new Date(value))
  startDate: Date;

  @IsDate({ message: 'Please select a valid end date' })
  @Transform(({ value }) => new Date(value))
  endDate: Date;

  @IsBoolean({ message: 'Regional manager flag must be a boolean' })
  isRegionalManager: boolean;

  @ValidateIf((o) => o.isRegionalManager === true)
  @IsUUID(4, { message: 'Invalid region selected' })
  regionId?: string | null;

  @IsBoolean({ message: 'Automatic downline inheritance flag must be a boolean' })
  automaticDownlineInheritance: boolean;

  @IsBoolean({ message: 'Complete user visibility flag must be a boolean' })
  completeUserVisibility: boolean;

  /**
   * Controls whether the agent can create sub-agents.
   * Defaults to true if not specified.
   */
  @IsOptional()
  @IsBoolean({ message: 'canCreateSubAgents must be a boolean value' })
  canCreateSubAgents?: boolean;
}
